import axios from "axios";
import { Message } from "element-ui";
// import store from "@/store";
import { getToken } from "@/utils/auth";
import errorCode from "@/utils/errorCode";
// import { getPath } from "@/utils/tool";
// 是否显示重新登录
export let isRelogin = { show: false };
axios.defaults.headers["Content-Type"] = "application/json;charset=utf-8";
axios.defaults.headers["language"] = "zh";
// 创建axios实例
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  // 超时
  timeout: 30000,
});
// request拦截器
service.interceptors.request.use(
  (config) => {
    // 是否需要设置 token
    const isToken = (config.headers || {}).isToken === false;
    if (getToken() && !isToken) {
      config.headers["authorization-token"] = getToken(); // 让每个请求携带自定义token 请根据实际情况自行修改
    }
    // get请求映射params参数
    if (config.method === "get" && config.params) {
      let url = config.url + "?";
      for (const propName of Object.keys(config.params)) {
        const value = config.params[propName];
        const part = encodeURIComponent(propName) + "=";
        // console.log("value :>> ", value, typeof value, value.length);
        if (value !== null && typeof value !== "undefined") {
          // console.log("object :if>> ", value);
          if (typeof value === "object") {
            for (const key of Object.keys(value)) {
              let params = propName + "[" + key + "]";
              const subPart = encodeURIComponent(params) + "=";
              url += subPart + encodeURIComponent(value[key]) + "&";
            }
          } else {
            if (typeof value === "string") {
              if (value.length !== 0) {
                url += part + encodeURIComponent(value) + "&";
              }
            } else {
              url += part + encodeURIComponent(value) + "&";
            }
          }
        }
      }
      url = url.slice(0, -1);
      config.params = {};
      config.url = url;
    }
    return config;
  },
  (error) => {
    console.log(error);
    Promise.reject(error);
  }
);

// 响应拦截器
service.interceptors.response.use(
  async (res) => {
    // 未设置状态码则默认成功状态
    const code = res.data.code || 200;
    // 获取错误信息
    const msg = res.data.msg || errorCode[code] || errorCode["default"];
    if (code === 401 || code === 1001) {
      return Promise.reject(code);
    } else if (code === 500) {
      Message({
        message: msg,
        type: "error",
      });
      return Promise.reject(new Error(msg));
    } else if (code === 501) {
      Message({
        type: "error",
        duration: 0,
        message: msg,
      });
      return Promise.reject(new Error(msg));
    } else if (code !== 200) {
      if (msg === "无效的刷新令牌") {
        // hard coding：忽略这个提示，直接登出
        console.log(msg);
      } else {
        Message.error(msg);
      }
      return Promise.reject("error");
    } else {
      return res.data;
    }
  },
  (error) => {
    console.log("err" + error);
    let { message } = error;
    if (message === "Network Error") {
      message = "后端接口连接异常";
    } else if (message.includes("timeout")) {
      message = "系统接口请求超时";
    } else if (message.includes("code 401")) {
      return handleAuthorized();
    } else if (message.includes("Request failed with status code")) {
      message = "系统接口" + message.substr(message.length - 3) + "异常";
    }
    Message({
      message: message,
      type: "error",
      duration: 5 * 1000,
    });
    return Promise.reject(error);
  }
);

function handleAuthorized() {
  if (!isRelogin.show) {
    isRelogin.show = true;
    // MessageBox.confirm(
    //   "登录状态已过期，您可以继续留在该页面，或者重新登录",
    //   "系统提示",
    //   {
    //     confirmButtonText: "重新登录",
    //     cancelButtonText: "取消",
    //     type: "warning",
    //   }
    // )
    //   .then(() => {
    //     isRelogin.show = false;
    //     store.dispatch("LogOut").then(() => {
    //       location.href = getPath("/index");
    //     });
    //   })
    //   .catch(() => {
    //     isRelogin.show = false;
    //   });
  }
  return Promise.reject("无效的会话，或者会话已过期，请重新登录。");
}

export default service;
